import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { QuantityInputComponent } from './quantity-input.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    QuantityInputComponent
  ],
  exports: [
    QuantityInputComponent
  ]
})
export class QuantityInputModule { }
